import { Fragment } from "react";
import clsx from "clsx";
import { TextBadge, Subtitle, SectionTitle } from "components/atoms/Text";
import StepCard from "components/organism/Cards/StepCard";
import { StepList } from "data";

const HowItWorks = () => {
    return (
        <Fragment>
            <section className={clsx(
                "w-full",
                "px-6 tablet:px-8 desktop:px-[120px]",
                "py-[96px] tablet:py-16 phone:py-12 text-center bg-neutral-20 overflow-hidden"
            )}>
                <div className="max-w-[1440px] mx-auto relative">
                    <img src="/images/affiliates/howitworks/brick.svg" className="w-[116px] h-[118px] tablet:w-[82px] tablet:h-[84px] desktop:left-[-25px] desktop:top-[67px] phone:w-[93px] phone:h-[95px] phone:top-[158px] absolute tablet:top-[93px] top-[162px] phone:left-[-44px] left-[96px] tablet:left-[4px]" alt="brick" />
                    <img src="/images/affiliates/howitworks/brick-bottom.svg" className="w-[152px] h-[170px] tablet:w-[111px] tablet:h-[124px] phone:w-[107px] phone:h-[119px] absolute right-[61px] desktop:bottom-[-67px] desktop:right-[-60px] tablet:right-[-36px] tablet:bottom-[-58px] bottom-[28px] phone:right-[-37px] phone:bottom-[-65px]" alt="brick" />
                    <div className="tablet:max-w-[796px] mx-auto">
                        <TextBadge>How it work</TextBadge>
                        <SectionTitle>How Does it Work?</SectionTitle>
                        <Subtitle classNames="max-w-[518px] mx-auto !text-lg !leading-[30.8px]">Submit your inquiry and become Anonymous Proxies affiliate partner in just a few days.</Subtitle>
                    </div>
                    <section className={clsx(
                        "grid grid-cols-1 md:grid-cols-3 tablet:gap-6 phone:gap-6 gap-8",
                        "pt-[72px] tablet:pt-[56px] phone:pt-[40px] px-6 phone:px-0 tablet:px-0 desktop:px-0"
                    )}>
                        {StepList.map((item) => (
                            <StepCard key={item.id} icons={item.icons} title={item.title} description={item.description} />
                        ))}
                    </section>
                </div>
            </section>
        </Fragment>
    );
};

export default HowItWorks;